import { Component, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { TranslatorService } from "src/app/core/translator/translator.service";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { FormsModule } from "@angular/forms";
import { NgFor, NgIf } from "@angular/common";
import { CartService } from "src/app/core/shop/cart.service";

const RETURN_URL_KEY = "hxa_return_url";

@Component({
  selector: "app-public-header",
  templateUrl: "./public-header.component.html",
  styleUrls: ["./public-header.component.scss"],
  imports: [FormsModule, NgFor, NgIf, RouterLink, TranslatePipe],
})
export class PublicHeaderComponent implements OnInit {
  selectedLanguage: string;
  cartItemCount = 0;

  constructor(
    public translator: TranslatorService,
    public oidcSecurityService: OidcSecurityService,
    private router: Router,
    private cartService: CartService,
  ) {}

  ngOnInit() {
    this.translator.selectedLanguage.subscribe((r) => {
      this.selectedLanguage = r;
    });

    this.cartService.cartItems.subscribe((items) => {
      this.cartItemCount = items.reduce((sum, item) => sum + item.quantity, 0);
    });
  }

  getLangs() {
    return this.translator.getAvailableLanguages();
  }

  setLang(value) {
    this.translator.useLanguage(value);
  }

  login() {
    localStorage.setItem(RETURN_URL_KEY, this.router.url);
    this.oidcSecurityService.authorize();
  }

  goToCart() {
    this.router.navigate(["/public/cart"]);
  }
}
